export default __webpack_public_path__ + "static/files-3c351d2e3be8094583477697e6750f72.png";